<template>
  <v-container>
    <v-form id="regForm" ref="form" v-model="valid" lazy-validation v-if="centerId">

      <v-text-field class="d-none" v-model="answer" label="answer"></v-text-field>

      <v-card class="pa-5 mb-2" v-if="$route.params.centerId.indexOf('practice') >= 0">
        <v-row>
          <v-col cols="12">
            <v-select
              label="Practice Student Data"
              :items="practiceData"
              item-text="name"
              :return-object="true"
              @change="prefillData"
            ></v-select>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="pa-5 mb-2">
        <div v-for="(student, index) in form.students" :key="index">
          <h3>Student {{ index + 1}} Information</h3>

          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="student.firstName"
                label="First Name"
                class="required"
                :rules="requiredRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="student.lastName"
                label="Last Name"
                class="required"                :rules="requiredRules"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="3">
              <v-select
                v-model="student.gender"
                label="Gender"
                :items="globals.genders"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="student.school"
                label="School"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <DatePicker v-model="student.dob"></DatePicker>
            </v-col>
            <v-col cols="12" sm="2">
              <v-select
                v-model="student.grade"
                label="Grade"
                :items="globals.grades"
                class="required"                :rules="requiredRules"
              ></v-select>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col>
            <v-btn class="secondary" v-if="form.students.length < maxStudents" @click="addStudent">Add Another Student</v-btn>
          </v-col>
          <v-col align="right">
            <v-btn class="warning" v-if="form.students.length > 1" @click="removeStudent">Remove Student</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="pa-5 mb-2">
        <h3>Address</h3>

        <v-row>
          <v-col cols="8" sm="8">
            <v-text-field
              id="address1"
              v-model="form.address.address1"
              label="Address"
              class="required"              :rules="requiredRules"
              placeholder=""
            ></v-text-field>
          </v-col>
          <v-col cols="4" sm="4">
            <v-text-field
              v-model="form.address.address2"
              label="Apt, Suite, etc."
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="form.address.city"
              label="City"
              class="required"              :rules="requiredRules"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-autocomplete
              v-model="form.address.state"
              label="State"
              :items="globals.states"
              class="required"              :rules="requiredRules"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              v-model="form.address.zip"
              label="Zip"
              class="required"              :rules="requiredRules"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="pa-5 mb-2">
        <h3>Parent/Guardian Information</h3>

        <v-row>
          <v-col cols="12" sm="6">
            <h4>Parent/Guardian 1</h4>
            <v-row>
              <v-col cols="8" sm="8">
                <v-text-field
                  v-model="form.parents[0].name"
                  label="First and Last Name"
                  class="required"                  :rules="requiredRules"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="4">
                <v-select
                  v-model="form.parents[0].relationship"
                  label="Relationship"
                  :items="globals.relationships"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" sm="8">
                <v-text-field
                  v-model="form.parents[0].phone"
                  label="Phone"
                  class="required"                  :rules="[...requiredRules, ...phoneRules]"
                  v-mask="'###-###-####'"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="4">
                <v-select
                  v-model="form.parents[0].phoneType"
                  label="Type"
                  :items="globals.phoneTypes"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="form.parents[0].email"
                  label="Email"
                  class="required"                  :rules="[...requiredRules, ...emailRules]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <h4>Parent/Guardian 2</h4>
            <v-row>
              <v-col cols="8" sm="8">
                <v-text-field
                  v-model="form.parents[1].name"
                  label="First and Last Name"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="4">
                <v-select
                  v-model="form.parents[1].relationship"
                  label="Relationship"
                  :items="globals.relationships"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" sm="8">
                <v-text-field
                  v-model="form.parents[1].phone"
                  label="Phone"
                  :rules="phoneRules"
                  v-mask="'###-###-####'"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="4">
                <v-select
                  v-model="form.parents[1].phoneType"
                  label="Type"
                  :items="globals.phoneTypes"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="form.parents[1].email"
                  label="Email"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="pa-5 mb-2">
        <v-row>
          <v-col cols="12" sm="6">
            <v-select
              v-model="form.referredBy"
              label="Referred by"
              :items="globals.referredBySources"
            ></v-select>
          </v-col>
        </v-row>

        <v-checkbox color="primary" v-model="acceptPolicy" :rules="requiredRules" class="required">
          <span slot="label">I acknowledge that I have read and understood the <a @click.stop="policyDialog = true; acceptPolicy = !acceptPolicy">Rules and Policies</a></span>
        </v-checkbox>

        <v-row align="start">
          <v-col>
            <SignaturePad ref="signaturePad" required message="Your signature is required"></SignaturePad>
          </v-col>
          <v-col align="left">
            <v-btn @click="$refs.signaturePad.clear()">Clear</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-row>
        <v-col cols="6">
          <v-btn color="primary" :disabled="!valid" :loading="submitting" @click="submitForm()">Submit</v-btn>
        </v-col>
        <v-col cols="6" align="right">
          <v-btn color="secondary" @click="clearForm()">Clear Form</v-btn>
        </v-col>
      </v-row>

    </v-form>

    <div v-else>
      Center {{ this.$route.params.centerId }} not found.
    </div>

    <v-dialog
      v-model="policyDialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title class="headline">Rules and Policies</v-card-title>
        <v-card-text>
          <p><ol>
            <span v-for="(section, index) of policy.sections" :key="index">
              <h3>{{ section.title }}</h3>
              <li v-for="(rule, index) of section.rules" :key="index" v-html="rule"></li>
            </span>
          </ol></p>
          <p v-for="(footer, index) of policy.footer" :key="index" v-html="footer"></p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="policyDialog = false; acceptPolicy = true">I Accept</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :bottom=true color="error" :timeout=4000 >{{ errorMessage }}</v-snackbar>

  </v-container>

</template>

<script>
import { mask } from 'vue-the-mask'
import globals from "../data/globals"
import practiceData from "../data/practice-data"
import SignaturePad from "../components/SignaturePad"
import DatePicker from "../components/DatePicker"
import api from "../api"

const blankStudent = {
  firstName: "",
  lastName: "",
  gender: "",
  school: "",
  dob: "",
  grade: null,
}
const blankParent = {
  name: "",
  relationship: "",
  phone: "",
  type: "",
  email: "",
}

const reEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const autocompleteFields = {
  street_number: "street",
  route: "route",
  locality: "city",
  administrative_area_level_1: "state",
  postal_code: "zip"
};

const gradeAge = {
  PreK: 4,
  K: 5,
  0: 5,
}

export default {
  name: 'Centers',
  components: {
    SignaturePad,
    DatePicker,
  },
  directives: {
    mask,
  },
  data: () => ({
    centerId: true,
    globals: globals,
    practiceData: practiceData,
    form: {
      students: [Object.assign({...blankStudent})],
      address: {
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        street: "",
        route: "",
      },
      parents: [{
        name: "",
        relationship: "",
        phone: "",
        phoneType: "",
        email: "",
      }, {
        name: "",
        relationship: "",
        phone: "",
        phoneType: "",
        email: "",
      }],
      referredBy: "",
    },
    maxStudents: 4,
    policy: {},
    policyDialog: false,
    acceptPolicy: false,

    valid: true,
    requiredRules: [
      v => !!v || "This field is required",
    ],
    phoneRules: [
      v => !v || (v.length === 0 || v.length === 12) || "Invalid phone number",
    ],
    emailRules: [
      v => !v || reEmail.test(v) || "Invalid email address",
    ],
    snackbar: false,
    errorMessage: "",
    answer: "",
    signature: "",
    submitting: false,

    autocomplete: null,
  }),
  mounted() {
    window.scrollTo(0,0)

    // practice center
    if (this.$route.params.centerId.startsWith("practice")) {
      this.centerId = this.$route.params.centerId
      api.getPolicy().then(result => {
        this.policy = result.data
      }).catch()
      return
    }

    api.getCenters().then(result => {
      this.centers = result.data

      const center = this.centers.find(x => this.$route.params.centerId === x.slug)
      if (center) {
        this.centerId = center.slug

        api.getPolicy(this.centerId).then(result => {
          this.policy = result.data
        }).catch()

        const autocompleteOpts = {
          types: ["geocode"],
          componentRestrictions: {country: "us"}
        }
        const el = document.getElementById("address1")
        this.autocomplete = new window.google.maps.places.Autocomplete(el, autocompleteOpts)
        this.autocomplete.addListener("place_changed", this.fillInAddress)

        setTimeout(() => {
          var form = document.getElementById("regForm")
          for (let input of form) {
            if (input.type === "text") input.autocomplete="new-password"
          }
        },100)
        return
      }
      this.centerId = null
    })
  },
  methods: {
    addStudent () {
      this.form.students.push(Object.assign({}, blankStudent))
    },
    removeStudent () {
      this.form.students.pop()
    },
    prefillData (data) {
      this.form.students = data.students
      this.form.address = data.address
      this.form.parents = data.parents
      if (this.form.parents.length === 1) {
        this.form.parents.push(Object.assign({}, blankParent))
      }
    },
    fillInAddress () {
      const place = this.autocomplete.getPlace()

      for (let component of place.address_components) {
        const type = component.types[0];

        if (autocompleteFields[type]) {
          this.form.address[autocompleteFields[type]] = component.short_name
        }
      }
      this.form.address.address1 = this.form.address.street + " " + this.form.address.route
    },
    capitalize (text) {
      if (text) {
        var names = text.trim().replace(/ +/g, " ").split(" ")

        for (var i = 0; i < names.length; i++) {
          if (names[i].length > 2) {
            names[i] = names[i].substring(0,1).toUpperCase() + names[i].substring(1).toLowerCase()
          }
        }
        return names.join(" ")
      }
      return text
    },
    dobRule (dob, grade) {
      const d = new Date(dob)
      const diff = new Date(Date.now() - d.getTime())
      const age = diff.getUTCFullYear() - 1970

      let target = gradeAge[grade]

      if (target != null) target = gradeAge[0] + grade
      if (Math.abs(target - age) > 1) {
        return "Date of birth does not match grade"
      }
      return ""
    },
    clearForm () {
      this.$refs.form.reset()
      this.$refs.signaturePad.clear()
      this.answer = ""
    },
    submitForm () {
      if (this.answer !== "") return false

      for (let student of this.form.students) {
        student.firstName = this.capitalize(student.firstName)
        student.lastName = this.capitalize(student.lastName)
      }
      for (let parent of this.form.parents) {
        parent.name = this.capitalize(parent.name)
      }

      if (!this.$refs.form.validate()) {
        this.errorMessage = "Please check to make sure all required fields are filled out correctly."
        this.snackbar = true
        return false
      }
      if (!this.$refs.signaturePad.validate()) {
        this.errorMessage = "Please sign in the signature box."
        this.snackbar = true
        return false
      }
      this.submitting = true
      this.signature = this.$refs.signaturePad.toDataURL()
      api.submitForm(this.$route.params.centerId, this.form, this.$refs.signaturePad.toDataURL(), this.policy)
      .then(() => {
        this.$router.push({ name: "success" })
      })
      .catch(() => {
        this.submitting = false
        this.errorMessage = "Error submitting form. Please try again later."
        this.snackbar = true
      })
    }
  },
}
</script>

<style>
.required label::after {
  content: " *";
}
</style>
